import { getCurrentUser } from '../auth';

export type AuthEventType =
  | 'sign_in_success'
  | 'sign_in_failure'
  | 'sign_up_success'
  | 'sign_up_failure'
  | 'sign_out'
  | 'password_reset_request'
  | 'password_reset_request_failure'
  | 'password_reset_complete'
  | 'password_reset_complete_failure';

export interface AuthEventPayload {
  eventType: AuthEventType;
  email: string;
  uid: string | null;
  success: boolean;
  errorCode: string | null;
  errorMessage: string | null;
  userAgent: string;
  platform: string;
  metadata?: Record<string, unknown>;
}

async function sendAuthEvent(apiUrl: string, payload: AuthEventPayload): Promise<void> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };

  const user = getCurrentUser();
  if (user) {
    try {
      const token = await user.getIdToken();
      headers['Authorization'] = `Bearer ${token}`;
    } catch {
      // Token retrieval failed — proceed without auth header
    }
  }

  await fetch(apiUrl, { method: 'POST', headers, body: JSON.stringify(payload) });
}

export function logAuthEvent(apiUrl: string, payload: AuthEventPayload): void {
  sendAuthEvent(apiUrl, payload).catch((err: unknown) => {
    console.error('Auth event logging failed (non-blocking):', err);
  });
}
